export const TurnkeyProvider = {
    Email: 'email',
    Google: 'google',
    Apple: 'apple',
};
